import { extend } from "vee-validate";
// eslint-disable-next-line camelcase
import { required, email, min_value, min, max_value, digits, regex } from "vee-validate/dist/rules";

// See https://github.com/logaretm/vee-validate

extend("min", {
    ...min,
    message: "Too short",
});

extend("url", {
    validate: (str) => {
        const pattern = new RegExp("^(https?:\\/\\/)?" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
            "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
            "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
            "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$", "i"); // fragment locator
        return !!pattern.test(str);
    },
    message: "آدرس معتبر نمی باشد",
});


extend("domain", {
    validate: value => {
      const domainRegex = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
      return domainRegex.test(value);
    },
    message: "لطفا یک دامنه معتبر وارد کنید"
  });


extend("email", {
    ...email,
    message: "Invalid email address",
});

extend("required", {
    ...required,
    message: "{_field_} اجباری می باشد"
});
extend("digits", {
    ...digits,
    message: "{_field_} نمی تواند کمتر از {length} باشد. ({_value_})"
});
extend("min_value", {
    ...min_value,
    message: "{_field_} نمی تواند کمتر از {min} باشد. ({_value_})"
});
extend("max_value", {
    ...max_value,
    message: "{_field_} نمی تواند بیشتر از {max} باشد. ({_value_})"
});
extend("regex", {
    ...regex,
    message: "{_field_} در قالب  {regex} نمی باشد. ({_value_})"
});